import clsx from "clsx";
import { motion } from "framer-motion";
import React, { DetailedHTMLProps, FC, HTMLAttributes, PropsWithChildren } from "react";

import { PortraitCardProps } from "./portrait-card";

const wrapperVariants = {
  animate: (hover: boolean) => ({
    height: hover ? "100%" : "auto",
  }),
};

interface PortraitCardInnerProps
  extends Pick<PortraitCardProps, "titleLine1" | "titleLine2" | "subtitle">,
    DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  isHover?: boolean;
}

export const PortraitCardInner: FC<PropsWithChildren<PortraitCardInnerProps>> = ({
  titleLine1,
  titleLine2,
  subtitle,
  children,
  isHover,
  className,
}) => (
  // Motion is needed as css cant handle transitions between heigh which are not numerical
  <motion.div
    variants={wrapperVariants}
    custom={isHover}
    initial={false}
    animate="animate"
    transition={{
      ease: "easeOut",
      duration: 0.4,
    }}
    className={clsx("flex flex-col justify-start bg-primary", className)}
  >
    <div className="text-light flex-none p-4 pb-6">
      {titleLine1 && <div className="text-3xl">{titleLine1}</div>}
      {titleLine2 && <div className="text-3xl mb-2">{titleLine2}</div>}
      {subtitle && <div className="text-base font-light leading-snug">{subtitle}</div>}
    </div>
    {children && <div className="relative">{children}</div>}
  </motion.div>
);
